<script lang="ts">
    import {router} from 'tinro';

    import List, {Item, Graphic, Separator, Text, PrimaryText, SecondaryText} from '@smui/list';
    import Menu, {SelectionGroup, SelectionGroupIcon} from '@smui/menu';
    import Textfield from '@smui/textfield';
    import Icon from '@smui/textfield/icon';
    import IconButton, {Icon as BtnIcon} from '@smui/icon-button';
    import ActorEditor from "./ActorEditor.svelte"

    import type {Actor, ReadyList} from "./jmdb"
    import {newId} from "./jmdb"
    import {actor_list, job_names, role_list} from "./jmdb"
    
    export let actor_id: string = ""
    let newActorSelected = false
    $: newActorSelected = (actor_id == newId.toString())
    

    let filterText = ''
    let filterBox: Menu
    let jobFilter = ''
    let selectedActor: Actor | undefined

    $: selectedActor = newActorSelected ? {
            'id': newId,
            'name': '',
            'desc': '',
            'email': '',
            'job': "viewer",
            'role': 0,
            'specialRights': {streamerGroups:{}, streamers: {}}
        } : $actor_list.data.find((v) => v.id == Number(actor_id))

    let actor_list_sorted: ReadyList<Actor>
    // map(v=>v) is for creating a clone
    $: actor_list_sorted = {ready: $actor_list.ready, data: $actor_list.data.map(v=>v).sort((a, b) => a.name.localeCompare(b.name))} 

    actor_list.fetch()
    role_list.fetch()
</script>


<div class="row">
    <div class="col-md-3">
        <div style="display: flex; flex-wrap: nowrap;">
            <Textfield withLeadingIcon label="Find" bind:value={filterText} >
                <Icon class="material-icons">search</Icon>
            </Textfield>
            
            <IconButton class="material-icons-outlined col-md-2 {(!jobFilter)?'md-gray':''}" on:click={() => {filterBox.setOpen(true)}} ripple={false}>filter_alt</IconButton>
            <Menu bind:this={filterBox} class="z-menu">
            <List>
                <SelectionGroup>
                {#each ['', 'su', 'team_mgr', 'multi_mgr'] as item}
                    <Item on:SMUI:action={() => jobFilter = item} selected={jobFilter === item}>
                    <SelectionGroupIcon>
                        <i class="material-icons">check</i>
                    </SelectionGroupIcon>
                    <Text>{job_names[item]}</Text>
                    </Item>
                {/each}
            </SelectionGroup>    
            <Separator />
            <Item on:SMUI:action={() => filterBox.setOpen(false)}><Text>Close</Text></Item>
            </List>
        </Menu>
        </div>

    </div>
</div>
<div class="row">
    <div class="col-md-3 user-list">
        {#if !actor_list_sorted.ready}
            Loading...
        {:else}
            <List class="demo-list" twoLine singleSelection>
                {#each actor_list_sorted.data as actor}
                {#if (!filterText || actor.name.toLowerCase().indexOf(filterText.toLowerCase()) != -1) && (!jobFilter || actor.job == jobFilter)}
                <Item selected={actor.id == Number(actor_id)}>
                    <a class="divLink" href="/mgr/actors/{actor.id}">&nbsp;</a>
                    <Text>
                    <PrimaryText>{actor.name}</PrimaryText>
                    <SecondaryText>{job_names[actor.job]}</SecondaryText>
                    </Text>
                </Item>
                <Separator />
                {/if}
                {/each}
            </List>
            <List class="demo-list" singleSelection>
                <Item selected={newActorSelected}>
                    <a class="divLink" href="/mgr/actors/{newId}">&nbsp;</a>
                    <Graphic class="material-icons">add</Graphic>
                    <Text>New person</Text>
                </Item>
            </List>
        {/if}
    </div>
    <div class="col-md-9">
        {#if !selectedActor }
            Nothing is selected
        {:else}
            {#key selectedActor}
            <ActorEditor actor={JSON.parse(JSON.stringify(selectedActor))} />
            {/key}
        {/if}
    </div>

</div>